/**
 * Get Tencent CDN base URL based on environment
 */
function getTencentCdnBaseUrl(): string {
  return `https://${import.meta.env.VITE_TENCENT_CDN_HOST}`;
}

/**
 * Construct deal image URL using Tencent CDN structure
 * Template: {TENCENT_IMAGE_URL_ROOT}/images/products/{product_id}/main/{image_name}/{image_type}_{image_resolution}
 */
export function getDealImageUrl(
  productId: string,
  imageName: string,
  imageType = "full",
  imageResolution = "2x"
): string {
  if (!productId || !imageName) return "";

  // If imageName is already a full URL, return it as-is
  if (imageName.startsWith("http://") || imageName.startsWith("https://")) {
    return imageName;
  }

  const tencentCdnBase = getTencentCdnBaseUrl();
  return `${tencentCdnBase}/images/products/${productId}/main/${imageName}/${imageType}_${imageResolution}`;
}
